function Defense(){
    return (
        <div className="text-orange-400 text-center font-extrabold text-4xl">
            <div>Number 1</div>
            <div>Number 2</div>
            <div>Number 3</div>
            <div>Number 4</div>


        </div>
    )

}
export default Defense;